import { Box, styled } from '@mui/material'
import { Skeleton } from '@mui/material'

export const LogoContainer = styled(Box)`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 100%;
`

export const LogoImage = styled('img')`
  height: 60%;
  width: auto;
`

export const LogoSkeleton = styled(Skeleton)`
  height: 50%;
  width: auto;
  min-width: 300px;
  background-color: ${({ theme }) => theme.palette.secondary.light};
`
